<div class="container-fluid pb-4 pt-4">
  <app-breadcrumb currentRouteName="Ressources documentaires"></app-breadcrumb>
  <h1 class="pt-3 pb-2">Ressources documentaires</h1>
  @if(resources) {
    @if(resources.length > 0) {
      <div class="d-flex gap-3 min-height-pdf-viewer">

        <div class="flex-grow-1 w-25">
          <!--          <form class="d-none d-md-flex input-group pe-0 ps-0 position-relative pb-3">-->
          <!--            <input placeholder="Rechercher par mot(s) clé(s)" class="form-control">-->
          <!--            <button type="submit" class="btn btn-primary">-->
          <!--              <fa-icon icon="search"></fa-icon>-->
        <!--            </button>-->
      <!--          </form>-->
      <app-search-bar (search)="search = $event"></app-search-bar>
      <button class="btn btn-outline-primary mb-3 me-2" (click)="showAll()">
        <fa-icon icon="plus"></fa-icon>
        <span class="d-none d-md-inline"> Tout déplier</span>
      </button>
      <button class="btn btn-outline-primary mb-3" (click)="hideAll()">
        <fa-icon icon="minus"></fa-icon>
        <span class="d-none d-md-inline"> Tout replier</span>
      </button>

      <app-resources-tree
        [markjsHighlight]="search"
        [deepness]="0"
        [search]="search"
        [resources]="resources | search:search:true:['category','title']"
        [showall]="$showall"
        [hideall]="$hideall"
        (blob)="selectFile($event)"
        (loading)="onPdfLoading($event)">
      </app-resources-tree>
    </div>

    <div class="flex-grow-1 w-75 d-none d-xl-block">
      @if (!showPdf && !loadingPdf) {
        <div class="alert alert-info text-center pb-4 pt-4">
          <fa-icon icon="info-circle"></fa-icon>
          Sélectionnez un document pour le visualiser ou le télécharger
        </div>
      }
      @if (loadingPdf) {
        <div class="pdf-loading-overlay">
          <ls-spinner/>
          <p class="mt-3 text-muted">Chargement du document...</p>
        </div>
      }
      <div [class.d-none]="!showPdf || loadingPdf" class="pdf-viewer">
        <ng2-pdfjs-viewer [openFile]="false" [page]="1" [externalWindow]="false" #pdfViewer></ng2-pdfjs-viewer>
      </div>
    </div>
  </div>
} @else {
  <div>
    <div class="alert alert-info">
      <fa-icon icon="info-circle"></fa-icon>
      Aucune ressource accessible
    </div>
  </div>
}
} @else {
  <div class="pt-5">
    <ls-spinner/>
  </div>
}
</div>

